import template from './NotificationView.hbs';

import './NotificationView.less';
import {BaseView, Prototype} from '../../../shared/view/BaseView';

/**
 * @class NotificationView
 * @extends BaseView
 */
@Prototype({
    template,
    ui: {
        'close': '.notification-view-close',
    },
    events: {
        'click @ui.close': 'onClose'
    },
    defaultOptions: {
        autoCloseTimerId: null,
        autoCloseTime: 5000,
        hiddenClass: 'notification-view--hidden',
        responseCode : 0,
        isWarning: false,
        isMessage: false,
        isSuccess: false,
        autoClose: true,
        content: ''
    }
})
export class NotificationView extends BaseView {

    get className () {
        return 'notification-view notification-view--hidden'
            + ` notification-view--${this.getType(this.options)}`;
    }

    initialize (options) {
        this.options = _.extend({}, this.defaultOptions, options);
    }

    serializeData () {

        const isContentObject = _.isObject(this.options.content);

        return {
            isContentObject,
            content: this.options.content,
            autoClose: this.options.autoClose,
            autoCloseTime: this.options.autoCloseTime,
            icon: this.getIcon(this.options),
            closeNotification: () => this.onClose()
        };
    }

    onAttach () {
        this.activate();
    }

    getType (options) {
        if (options.isWarning) {
            return 'warning';
        }
        if (options.isMessage) {
            return 'message';
        }
        if (options.isSuccess) {
            return 'success';
        }
        return 'danger';
    }

    getIcon (options) {
        const ICONS = {
            warning: 'warning',
            message: 'info',
            success: 'checkmark',
            danger: 'critical',
        };

        return ICONS[this.getType(options)];
    }

    activate () {
        if (this.options.autoClose) {
            this.options.autoCloseTimerId = setTimeout(() => this.onClose(), this.options.autoCloseTime);
        }

        this.$el.removeClass(this.options.hiddenClass);

        setTimeout(() => this.$('.radial-progress').addClass('radial-progress--live'), 100);
    }

    onClose (evt) {
        if (evt) {
            evt.stopPropagation();
        }

        if (this.options.autoCloseTimerId) {
            clearTimeout(this.options.autoCloseTimerId);
        }

        this.$el.addClass(this.options.hiddenClass);
        this.destroy();
    }

    onDestroy () {
        clearTimeout(this.options.autoCloseTimerId);
    }

}



// WEBPACK FOOTER //
// ./shared/view/NotificationView/NotificationView.js